import React, { useEffect } from "react";
import "./homepage.css";
import hero1 from "../componets/img/hero1.jpg";
import Nav from "../componets/nav";

const Homepage = () => {
  useEffect(() => {
    // Hide scrollbars when homepage mounts
    document.body.style.overflowY = "hidden";
    document.body.style.overflowX = "hidden";

    // Restore scrollbars when homepage unmounts
    return () => {
      document.body.style.overflowY = "auto";
      document.body.style.overflowX = "auto";
    };
  }, []);

  return (
    <div className="homepage">
      <Nav />
      <header
        className="hero-section"
        style={{ backgroundImage: `url(${hero1})` }}
      >
        <div className="hero-overlay">
          <div className="hero-content">
            <h1 className="hero-title">
              Chase speed.
              <br />
              Capture adrenaline.
              <br />
              Repeat.
            </h1>
            <p className="hero-subtext font-xxl">
              Epic car shots. Heart-pounding action. Memories that move as fast
              as you do.
            </p>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Homepage;
